<template>
  <div>
    <v-dialog
      v-model="show"
      max-width="400"
      @click:outside="cancel"
      content-class="rounded-xl"
    >
      <v-card class="pa-4">
        <div class="d-flex align-center justify-center flex-column gap-3">
          <h4 class="text-center mb-0">
            Quantos ingressos você deseja resgatar?
          </h4>
          <v-card
            outlined
            class="d-flex align-center justify-center rounded-pill gap-2"
          >
            <v-btn
              x-large
              icon
              @click="redeemQuantity--"
              :disabled="redeemQuantity <= 1"
            >
              <v-icon>mdi-minus</v-icon>
            </v-btn>
            <h4 class="text-center mb-0">{{ redeemQuantity }}</h4>
            <v-btn
              x-large
              icon
              @click="redeemQuantity++"
              :disabled="redeemQuantity >= max"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card>
          <small class="text-center text-grey">
            Limite de {{ max }} ingressos
          </small>
          <div class="d-flex flex-column align-center">
            <v-btn color="primary" @click="select" block>
              Resgatar {{ redeemQuantity }} ingressos
            </v-btn>
            <v-btn text @click="cancel" small> Cancelar </v-btn>
          </div>
        </div>
        <!-- <div
          class="d-flex flex-column align-center justify-space-between mt-3 gap-2 py-0"
        ></div> -->
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      redeemQuantity: 1,
      resolve: null,
      max: 1,
    };
  },
  methods: {
    async open(max) {
      return new Promise((resolve) => {
        this.show = true;
        this.max = max;
        this.redeemQuantity = max;
        this.resolve = resolve;
      });
    },
    select() {
      this.resolve(this.redeemQuantity);
      this.show = false;
    },
    cancel() {
      this.resolve(null);
      this.show = false;
    },
  },
  props: {
    promotion: {
      type: Object,
      required: true,
    },
  },
};
</script>
